(function( $ ) {
  'use strict';

  $(window).load(function() {
    $(".animated_data").each(function() {
      $(this).waypoint({
        handler: function() {
          $(this.element).find(".number").each(function(i, numberElement) {
            const animated = $(numberElement).data("animated");
            if (! animated) {
              let number = $(numberElement).data("number");
              number = typeof number === "string"
                ? parseInt(number.replaceAll(",", ""), 10)
                : parseInt(number, 10);

              $({ Counter: 0 }).animate(
                { Counter: number },
                {
                  duration: 15000,
                  easing: "swing",
                  step: function() {
                    $(numberElement).text(Math.ceil(this.Counter).toLocaleString());
                  },
                  complete: function() {
                    $(numberElement).text(number.toLocaleString());
                    $(numberElement).data("animated", "true");
                  }
                }
              );
            }
          })
        },
        offset: "75%"
      })
    })
  })
})( jQuery );
